import { VeltCursor } from '@veltdev/react';
import React, { useEffect } from 'react'
import './CursorPage.css';

function CursorPage() {

    useEffect(() => {
        
        window.onblur = (event) => {
            event.stopImmediatePropagation();
        };

        const queryParams = new URLSearchParams(window.location.search);

        const noBorderRadius = queryParams.get('noBorderRadius') || false;

        if (noBorderRadius) {
            document?.getElementById('modifier')?.classList?.add('no-border-radius');
        }

        const avatarMode = queryParams.get('avatarMode') || false;

        if (avatarMode) {
            document?.getElementById('modifier')?.classList.add('avatar-mode');
            document?.querySelector('velt-cursor')?.setAttribute('avatar-mode', 'true');
        }

        const replaceCursor = queryParams.get('replaceCursor') || false;

        if (replaceCursor) {
            const cursorElement = document.querySelector('velt-cursor');
            document?.getElementById('modifier')?.classList.add('replace-cursor');
            const img = document.createElement('img');
            img.src = 'https://img.icons8.com/ultraviolet/512/cursor--v2.png';
            img.width = 24;
            img.height = 24;
            img.alt = '';
            img.setAttribute('slot', 'cursor');
            cursorElement?.appendChild(img);
        }
    }, []);

    return (
        <div id="modifier">
            <VeltCursor />
        </div>
    )
}

export default CursorPage;